<div class="aig-contactform u-mt-7">
  <!-- #region TITLE -->
  <div class="row u-mb-4">
    <div class="col-12">
      <h2 class="u-h1 u-color-primary1 u-fw-400 u-text-center">
        Contrata tu póliza de seguro
      </h2>
    </div>
  </div>
  <!-- #endregion -->
  <div class="row">
    <div class="col-lg-9 col-md-12">
      <!-- #region FORM -->
      <form class="row" [formGroup]="contactForm">
        <!-- #region PRIMERA FILA -->
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label for="name-field" class="e-field__label">
              Nombre <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="name-field"
              formControlName="nombre"
              autocomplete="on"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label for="surname-field" class="e-field__label">
              Apellidos <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="surname-field"
              formControlName="apellidos"
              autocomplete="on"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label for="phone-number-field" class="e-field__label">
              Teléfono de contacto <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="phone-number-field"
              formControlName="telefono"
              autocomplete="on"
            />
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region SEGUNDA FILA -->

        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label for="nationality-field" class="e-field__label">
              Nacionalidad <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="nationality-field"
              formControlName="nacionalidad"
              autocomplete="on"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label
              for="dni-field"
              [ngClass]="registeredDni ? 'u-color-warning-error' : ''"
              class="e-field__label"
            >
              DNI/NIF/NIE <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              [ngClass]="registeredDni ? 'e-field__error' : ''"
              class="e-field__input form-control u-ps-2 u-py-1"
              id="dni-field"
              formControlName="dni"
              autocomplete="on"
            />
            <div class="u-text-start">
              <span
                class="e-field__error"
                *ngIf="
                  registeredDni && this.contactForm.controls['dni']?.touched
                "
                id="errorDni"
              >
                DNI con póliza ya contratada.
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="e-field">
            <label for="birthday-field" class="e-field__label">
              Fecha de nacimiento <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="date"
              class="e-field__input u-ps-2 u-py-1"
              id="birthday-field"
              formControlName="nacimiento"
              autocomplete="on"
            />
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region TERCERA FILA -->
        <div class="col-12 col-sm-12 col-lg-12 col-xl-4 col-xxl-4">
          <div class="e-field">
            <label for="surname-field" class="e-field__label">
              Dirección <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="surname-field"
              formControlName="direccion"
              autocomplete="on"
            />
          </div>
        </div>
        <div class="col-12 col-sm-12 col-lg-12 col-xl-8">
          <div class="row u-mx-0">
            <div class="col-4 u-ps-0">
              <div class="e-field">
                <label
                  for="block-field"
                  class="e-field__label u-size-per-15 u-ellipsis--line"
                >
                  Bloque/Escalera <span></span>
                </label>
                <input
                  type="text"
                  class="e-field__input u-ps-2 u-py-1"
                  id="block-field"
                  formControlName="bloque"
                  autocomplete="on"
                />
              </div>
            </div>
            <div class="col-4">
              <div class="e-field">
                <label for="floor-field" class="e-field__label">
                  Piso <span></span>
                </label>
                <input
                  type="text"
                  class="e-field__input u-ps-2 u-py-1"
                  id="floor-field"
                  formControlName="piso"
                  autocomplete="on"
                />
              </div>
            </div>
            <div class="col-4 u-pe-0">
              <div class="e-field">
                <label for="door-field" class="e-field__label">
                  Puerta <span></span>
                </label>
                <input
                  type="text"
                  class="e-field__input u-ps-2 u-py-1"
                  id="door-field"
                  formControlName="puerta"
                  autocomplete="on"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region CUARTA FILA -->
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4">
          <div class="p-flexcb u-gap-8">
            <div class="e-field u-size-per-70">
              <label for="province-field" class="e-field__label">
                Provincia <span class="u-color-warning-error">*</span>
              </label>
              <input
                type="text"
                class="e-field__input u-ps-2 u-py-1"
                id="province-field"
                formControlName="provincia"
                autocomplete="on"
              />
            </div>

            <div class="e-field u-size-per-30">
              <label for="pc-field" class="e-field__label">
                CP <span class="u-color-warning-error">*</span>
              </label>
              <input
                type="number"
                min="1"
                max="99999"
                class="e-field__input u-ps-2 u-py-1"
                id="pc-field"
                formControlName="cp"
                autocomplete="on"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-6 col-xl-3 col-xxl-4">
          <div class="e-field">
            <label for="location-field" class="e-field__label">
              Población <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="location-field"
              formControlName="poblacion"
              autocomplete="on"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-6 col-xl-3 col-xxl-4">
          <div class="e-field">
            <label for="country-field" class="e-field__label">
              País de residencia <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="text"
              class="e-field__input u-ps-2 u-py-1"
              id="country-field"
              formControlName="pais"
              autocomplete="on"
            />
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region QUINTA FILA: IBAN -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8">
          <aig-iban-field
            [parentForm]="contactForm"
            (ibanChange)="updateIban($event)"
            [mandatory]="ibanMandatory"
          ></aig-iban-field>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
          <div class="e-field">
            <label for="email-field" class="e-field__label">
              Correo electrónico <span class="u-color-warning-error">*</span>
            </label>
            <input
              type="email"
              class="e-field__input u-ps-2 u-py-1"
              id="email-field"
              formControlName="email"
              autocomplete="on"
            />
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region CHECKBOXES -->
        <div class="col-12 u-mt-7">
          <div class="row">
            <div class="col-12 u-mb-4">
              <p class="u-color-secondary1 u-fs-28">Por último</p>
            </div>
            <div class="col-12 p-flexcs u-gap-16 u-mb-4">
              <input
                class="aig-contactform__checkbox"
                type="checkbox"
                name="confirm-policy"
                id="confirm-policy"
                formControlName="aceptar"
              />
              <p class="u-fs-16 u-fw-400 u-color-secondary1">
                Confirmo que quiero contratar el seguro, que el tomador y asegurado de la póliza reside en España y que he leído y estoy de acuerdo con los
                <a
                  href="../../../../../assets/docs/TERMINOS Y CONDICIONES DE LA POLIZA.pdf"
                  download
                  class="aig-contactform__link u-color-primary3 u-cursor-pointer"
                  click-stop-propagation
                >
                  términos y condiciones de la póliza</a
                >, el documento de
                <a
                  href="../../../../../assets/docs/IPID.pdf"
                  download
                  class="aig-contactform__link u-color-primary3 u-cursor-pointer"
                  click-stop-propagation
                  >información sobre el producto de seguro (IPID)</a
                >, y los documentos con información general previa a la contratación de la compañía aseguradora AIG Europe S.A. Sucursal España
                <a
                  href="../../../../../assets/docs/Nota informativa de la Compañia - AIG.pdf"
                  download
                  class="aig-contactform__link u-color-primary3 u-cursor-pointer"
                  click-stop-propagation
                >
                  (Documento Información General Aseguradora) </a
                > y de Marsh S.A. Mediadores Seguros en base a sus
                <a
                  href="../../../../../assets/docs/Demandas y Necesidades - MARSH.pdf"
                  download
                  class="aig-contactform__link u-color-primary3 u-cursor-pointer"
                  click-stop-propagation
                >
                  demandas y necesidades </a
                > en virtud del siguiente documento.
              </p>
            </div>
            <div class="col-12 p-flexcs u-gap-16 u-mb-4">
              <input
                class="aig-contactform__checkbox"
                type="checkbox"
                name="confirm-pay"
                id="confirm-pay"
                formControlName="aceptar2"
              />
              <label
                class="u-fs-16 u-fw-400 u-color-secondary1"
                for="confirm-pay"
              >
                Autorizo a que AIG Europe, Surcursal España S.A. realice el cobro a través de domiciliación bancaria, en la cuenta que usted nos haya facilitado.
              </label>
            </div>
            <div class="col-12 p-flexcs u-gap-16">
              <input
                class="aig-contactform__checkbox"
                type="checkbox"
                name="data-protect"
                id="data-protect"
                formControlName="aceptar3"
              />
              <label
                class="u-fs-16 u-fw-400 u-color-secondary1"
                for="data-protect"
              >
                Marcando esta casilla, confirmo que he leído y acepto la <a class="u-color-primary3" href="../../../../../assets/docs/Consentimiento pa.pdf" target="_blank"> claúsula de protección de datos </a>.
              </label>
            </div>
          </div>
        </div>
        <!-- #endregion -->

        <!-- #region BUTTONS -->
        <div class="aig-contactform__foot col-12 p-flexce u-gap-24 u-mt-4">
          <a
            class="aig-contactform__btn e-btn e-btn--secondary e-btn--lg u-fw-600 p-flexcc u-cursor-pointer"
            href="/"
            id="go-back-button"
          >
            Atrás
          </a>
          <button
            id="confirm-btn"
            class="aig-contactform__btn e-btn e-btn--primary e-btn--lg u-fw-600 p-flexcc u-cursor-pointer"
            type="submit"
            (click)="sendData()"
            [disabled]="contactForm.invalid"
          >
            Contratar
          </button>
        </div>
        <!-- #endregion -->
      </form>
      <!-- #endregion -->
    </div>
    <div class="col-lg-3 col-md-12 u-mt-def">
      <!-- #region RESUMEN -->
      <div class="u-bg-disabled1 u-size-per-100 u-p-5 u-pb-9">
        <h3 class="u-color-primary1 u-fs-40 u-fw-400 u-family-aig u-mb-8">
          Resumen
        </h3>

        <div class="u-color-secondary1 u-mb-4">
          <div class="u-ds-flex u-justify-between u-fwrap-wrap">
            <strong class="u-fs-22"> Precio final </strong>
            <div class="p-flexce u-gap-12">
              <p class="u-fs-16">
                {{
                  precioFinal.toLocaleString("es-Es", {
                    minimumFractionDigits: 2
                  })
                }}€
              </p>
              <i class="icon-chevron-down"></i>
            </div>
          </div>
        </div>

        <p class="u-color-secondary1 u-fs-18 u-fw-600 u-my-7">
          La Caixa Ciberseguridad
        </p>

        <ul class="u-ps-0">
          <li
            *ngFor="let item of descriptions"
            class="u-color-secondary1 p-flexcs u-py-2 aig-contactform__border"
          >
            <div class="p-flexcb u-size-per-100">
              <p class="u-fs-14 u-fw-600">
                {{ item.title }}
              </p>
              <p class="u-fs-16">
                {{ item.value }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- #endregion -->
    </div>
  </div>
</div>
